<template>
    <div>
        <v-dialog
            v-model="showDialogContractDate"
            transition="dialog-top-transition"
            persistent
            width="500"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                    Update Contracted Date
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-menu
                                ref="mnuContractDate"
                                v-model="mnuContractDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="300px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <label>Contracted Date</label>
                                    <v-text-field
                                        v-model="contractDateFormatted"
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        @blur="contractDate = parseDate(contractDateFormatted);"
                                        readonly
                                        outlined
                                        single-line
                                        v-on="on"
                                        dense
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="contractDate"
                                    no-title
                                    @input="mnuContractDate = false"
                                    color="primary lighten-1"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-divider></v-divider>

				<v-card-actions style="padding: 15px !important;">
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonCancel v-btn-large"
							outlined
							@click="cancel"
						>
							Cancel
						</v-btn>

						<v-btn
							class="mx-2 v-btn-large"
							outlined
                            @click="confirm"
						>
							Confirm
						</v-btn>
					</div>
				</v-card-actions>

            </v-card>
        </v-dialog>
	</div>
</template>

<script>

    import Helpers from '@/utilities/Helpers';
    import { required } from "@/utilities/Rules";

	export default {

        mixins: [Helpers],

        props: {
			
            id: {
                type: Number,
                default: 0
            },

            setContractDate: {
                default: null
            },

			showDialogContractDate: {
				default: false
			},
		},

        watch: {
            async "setContractDate"() {
				if (this.setContractDate != null && this.setContractDate != undefined) {
                    this.contractDate = this.parseDate(this.setContractDate);
                    const dateParts = this.parseDate(this.setContractDate);
                    this.contractDateFormatted = dateParts;
                }
            },
            
            contractDate () {
                this.contractDateFormatted = this.formatDate(this.contractDate)
            },
        },
		
        data: () => ({
			
            today: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            contractDate: null,
            contractDateFormatted: null,
            mnuContractDate: false,

            validations: {
                required
            },
		}),

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

            cancel() {
                this.$emit('update:showDialogContractDate', false);
            },

            async confirm() {

                if (this.contractDate == null || this.contractDate == undefined || this.contractDate == "") {
                    this.showToast("error", "Error!", "Please enter the Contracted Date!");
                }
                else {
                    const request = {
                        idService: this.id,
                        dateContractRequest: {
                            dateContract: this.contractDate
                        }
                    }

                    const result = await this.$store.dispatch("serviceModule/UpdateDateContract", request);

                    if (result.success) {
                        this.showToast("success", "Success!", "Contracted Date updated successfully!");

                        this.$emit('methodConfirmToCall');
                    }
                    this.cancel();
                }
            }
        }
    };
</script>